import React from 'react';
import StatisticsSectionsSections from '../../components/ptgc/statistics/Index';  // ✅ Fix import

const StatisticsSectionsPage = () => {
  return (
    <>
      <StatisticsSectionsSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default StatisticsSectionsPage;